import React, { useContext, useEffect } from 'react';
import clx from 'classnames';
import { isDevelopment } from 'helpers/isDevelopment';
import './style.scss';
import { WebsocketActions, WebsocketContext } from 'services/WebsocketContext';
import { useSelector } from 'react-redux';
import {
  selectClientAccess,
  selectClientLogged,
  selectConsultantAccess,
  selectMeetingModeOffline,
} from 'stores/onlineForm/onlineForm';

interface ClientLoggedProps {
  formData?: GQL.ICacheContractOnlineForm;
}

const ClientLogged = ({ formData }: ClientLoggedProps) => {
  const wsContext = useContext(WebsocketContext);

  const isClientLogged = useSelector(selectClientLogged);
  const isConsultantAccess = useSelector(selectConsultantAccess);
  const isClientAccess = useSelector(selectClientAccess);
  const isOfflineMode = useSelector(selectMeetingModeOffline);

  useEffect(() => {
    if (isClientAccess) {
      wsContext.send({
        action: WebsocketActions.CLIENT_LOGGED,
        value: true,
      });
      return () => {
        wsContext.send({
          action: WebsocketActions.CLIENT_LOGGED,
          value: false,
        });
      };
    }
  }, [isClientAccess, wsContext]);

  useEffect(() => {
    wsContext?.ws?.on(WebsocketActions.CLIENT_LOGGED_INVALID, () => {
      if (isClientLogged) {
        wsContext.send({
          action: WebsocketActions.CLIENT_LOGGED,
          value: true,
        });
      }
    });
    return () => {
      wsContext?.ws?.off(WebsocketActions.CLIENT_LOGGED_INVALID);
    };
  }, [wsContext, isClientLogged]);

  useEffect(() => {
    if (isConsultantAccess) {
      wsContext.send({
        action: WebsocketActions.CLIENT_LOGGED_INVALID,
      });
    }
  }, [wsContext, isConsultantAccess]);

  if (isOfflineMode || isClientAccess) {
    return null;
  }

  return (
    <div
      className={clx([
        'client-logged',
        !isClientLogged ? 'not-logged' : '',
        isConsultantAccess ? 'show' : '',
        isDevelopment() ? 'development' : '',
      ])}
    >
      {isClientLogged ? 'Klient prihlásený' : 'Klient neprihlásený!'}
    </div>
  );
};

export default ClientLogged;
